export default __webpack_public_path__ + "static/media/apple-icon-180x180.3cf8cb82.png";